import React from 'react';
import styled from 'styled-components';
import { hooks } from '@engelvoelkersamericas/common-story-ui';
import { DateTime } from 'luxon';

const { useProfileState } = hooks;
function isToday(dateString) {
  const today = DateTime.local();

  // Extract just the date portion (YYYY-MM-DD) and parse as local date
  const datePart = dateString.substring(0, 10); // "2020-02-21"
  const date = DateTime.fromISO(datePart); // Parses as local date, not UTC

  return (
    date.day === today.day &&
    date.month === today.month
  );
}

export default function GreetingsHeader({ name = '' }) {
  const profile = useProfileState();
  const { birthDate, loginDate } = profile;
  function getGreetingsString() {
    const d = new Date();
    const h = d.getHours();

    if (birthDate && isToday(birthDate)) {
      return 'Happy Birthday';
    } else if (loginDate && isToday(loginDate)) {
      return 'Happy Anniversary';
    } else if (3 < h && h < 12) {
      return 'Good Morning';
    } else if (12 <= h && h < 17) {
      return 'Good Afternoon';
    } else if (17 <= h && h < 20) {
      return 'Good Evening';
    } else {
      return 'Goodnight';
    }
  }

  return (
    <Container>
      {getGreetingsString()}, {name}!
    </Container>
  );
}

const Container = styled.p`
  font-size: 2.8rem;
  text-align: center;
  margin-top: 40px;
  font-weight: 100;
  line-height: 1.39;
  letter-spacing: 1px;
  color: #444444;
  span {
    font-weight: 400;
  }
`;
